export default __webpack_public_path__ + "static/media/Resume.8ba83d01.pdf";